class Marketing {
  constructor(){
    this.checkIfUTMExists();
    this.updateFields();
  }

  getFromStorage(){
    this.utm = JSON.parse( localStorage.getItem('user_params') );
  }

  checkIfUTMExists(){
    const url = window.location.toString();
    const query = url.split("?");
    let params = {};
    if( query.length > 1 ){
      let pairs = query[1].split('&');

      pairs.forEach( item => {
        let val = item.split('=');
        params[val[0]] = val[1];
      })
      localStorage.setItem('user_params', JSON.stringify( params ) );

    }
  }

  updateFields() {
    this.getFromStorage();
    let area = document.querySelector('#hidden_area');
    if( this.utm  && area && typeof this.utm == 'object' ){
      for( let [index, value] of Object.entries( this.utm ) ){
        let element = document.createElement('input');
        element.setAttribute('type', 'hidden');
        element.setAttribute('name', index);
        element.setAttribute('value', value);

        area.append( element )
      }
    }

  }
}

export default Marketing;
